<template>
  <div class="hint">
    <TooltipProvider :delay-duration="200">
      <TooltipRoot>
        <TooltipTrigger as="div" class="hint_trigger">
          <slot />
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent
            class="metrica_tooltip"
            side="bottom"
            :side-offset="4"
            :collision-padding="8"
          >
            {{ text }}
            <TooltipArrow class="metrica_tooltip_arrow" :width="16" :height="8" />
          </TooltipContent>
        </TooltipPortal>
      </TooltipRoot>
    </TooltipProvider>
  </div>
</template>

<script>
import {
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
  TooltipPortal,
  TooltipContent,
  TooltipArrow,
} from 'reka-ui'

export default {
  props: ['text'],
  components: {
    TooltipProvider,
    TooltipRoot,
    TooltipTrigger,
    TooltipPortal,
    TooltipContent,
    TooltipArrow,
  },
}
</script>

<style scoped>
.hint {
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.hint_trigger {
  display: inline-flex;
  align-items: center;
}
</style>

<!-- контент тултипа телепортируется в body, поэтому стили глобальные -->
<style>
.metrica_tooltip {
  background-color: var(--tooltip-bg);
  border-radius: 7px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #ffffff;
  padding: 15px 20px;
  text-align: center;
  max-width: 320px;
  z-index: 9999;
}

.metrica_tooltip_arrow {
  fill: var(--tooltip-bg);
}

@media (max-width: 768px) {
  .metrica_tooltip {
    display: none;
  }
}
</style>
